import { formatTL } from "@/lib/api";
import { Card } from "@/components/ui/card";

const CARDS = [
  ["total_income", "Toplam gelir", "text-emerald-700"], ["total_expense", "Toplam gider", "text-red-600"], ["net", "Net kazanç", "text-slate-900"],
  ["pending_collections", "Bekleyen tahsilat", "text-amber-600"], ["completed_collections", "Tamamlanan tahsilat", "text-emerald-700"],
  ["pending_payments", "Bekleyen ödeme", "text-amber-600"], ["completed_payments", "Tamamlanan ödeme", "text-slate-700"],
  ["subscription_income", "Abonelik gelirleri", "text-emerald-700"], ["drone_income", "Drone çekim gelirleri", "text-emerald-700"],
  ["package_income", "Ek paket satışları", "text-emerald-700"], ["office_other_income", "Ofislerden diğer ödemeler", "text-emerald-700"], ["refunds", "İadeler", "text-red-600"],
];

export function FinCards({ s, only }) {
  const list = only ? CARDS.filter(([k]) => only.includes(k)) : CARDS;
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3" data-testid="fin-cards">
      {list.map(([k, l, c]) => (
        <Card key={k} className="p-4" data-testid={`fin-card-${k}`}>
          <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">{l}</div>
          <div className={`text-lg font-bold mt-1 ${c}`}>{formatTL(s?.[k] || 0)}</div>
        </Card>
      ))}
    </div>
  );
}

export function PeriodCards({ periods }) {
  if (!periods) return null;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="fin-periods">
      {[["today", "Bugün"], ["week", "Bu hafta"], ["month", "Bu ay"], ["year", "Bu yıl"]].map(([k, l]) => (
        <Card key={k} className="p-4" data-testid={`fin-period-${k}`}>
          <div className="text-xs font-semibold text-slate-500">{l}</div>
          <div className="text-sm mt-1">Gelir <b className="text-emerald-700">{formatTL(periods[k].income)}</b></div>
          <div className="text-sm">Gider <b className="text-red-600">{formatTL(periods[k].expense)}</b></div>
          <div className="text-sm">Net <b>{formatTL(periods[k].net)}</b></div>
        </Card>
      ))}
    </div>
  );
}
